{
  "(optional)": "(opcional)",
  "(required)": "(obrigatório)"
}